import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

import ActivityGroup from '../../components/ActivityGroup';
import { KeyboardingActivity, KeyboardingModule } from 'types/schema-generated-types';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      padding: theme.spacing(4),
      display: 'flex',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      // gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
      // gridTemplateRows: '1fr',
      gap: '16px'
    },
    cardHeaderContainer: {
      background: theme.palette.secondary.main
    }
  };
});

const AssessmentAcceleratorActivitiesList: React.FC<{
  keyboardingModules: KeyboardingModule[];
}> = ({ keyboardingModules }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {// eslint-disable-next-line react/display-name
      keyboardingModules[0].submodules?.map((module, index) => {
        return (
          <ActivityGroup
            key={index}
            title={module.name}
            activities={module.activities as KeyboardingActivity[]}
            subtitleGenerator={({ description }) => `${description}`}
            nameGenerator={({ title }) => `${title}`}
            paperStyle={{ maxWidth: '260px' }}
          />
        );
      })}
    </div>
  );
};

export default AssessmentAcceleratorActivitiesList;
